import * as routes from "../../Routing/routes";
import { PERMISSIONS } from "../../consts/permissions";
import { can } from "./can";

// First match wins, in sidebar order.
const MEMBER_LANDING = [
  [PERMISSIONS.MEMBER_PORTAL_OVERVIEW, routes.SOCIETY_PORTAL_MY_HOME],
  [PERMISSIONS.MEMBER_PORTAL_BILLS, routes.SOCIETY_PORTAL_MY_BILLS],
  [PERMISSIONS.MEMBER_PORTAL_PAYMENTS, routes.SOCIETY_PORTAL_MY_PAYMENTS],
  [PERMISSIONS.MEMBER_PORTAL_LEDGER, routes.SOCIETY_PORTAL_MY_LEDGER],
  [PERMISSIONS.MEMBER_PORTAL_COMPLAINTS, routes.SOCIETY_PORTAL_MY_COMPLAINTS],
  [PERMISSIONS.MEMBER_PORTAL_NOTICE_BOARD, routes.SOCIETY_PORTAL_NOTICE_BOARD],
];

// Where the portal's "/" sends this role: null for the admin dashboard, which
// needs dashboard.read, otherwise the page to go to. It follows the permissions
// alone, so ticking dashboard.read for any role gives it the dashboard.
export const portalLanding = (permissions) => {
  if (can(permissions, PERMISSIONS.DASHBOARD_READ)) return null;
  const member = MEMBER_LANDING.find(([perm]) => can(permissions, perm));
  return member ? member[1] : routes.SOCIETY_PORTAL_PROFILE;
};
